// extracted by mini-css-extract-plugin
export default {"tableRow":"LosTableRow_tableRow__whPmq"};